import React, { useEffect, useState } from 'react';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, CardBody, Col, Label, Row } from 'reactstrap';
import CurrencyInput from 'react-currency-input-field';

const initForm = {
    courbeDepreciation: '',
    vvadEsansCorrectif: '',
    correctifEtatVehicule: '',
    vvadEavecCorrectif1: '',
    correctifKilometrique: '',
    vvadEavecCorrectif2: '',
    correctifTotal: '',
    vvadEavecCorrectifTotal: '',
    epaveObtenueAssureur: '',
    differenceValeurs: '',
    correctifEV:""
};

const ResultatForm = ({ editingItem, formData, result }) => {
    const { t } = useTranslation('translation');
    const [form, setForm] = useState(initForm);
    const { vvinales } = useSelector(state => state.parametrage);

    const dispatch = useDispatch();


    useEffect(() => {
        if (result) {
            setForm({ ...result });
        }
    }, [result]);

    const formik = useFormik({
        initialValues: { ...form },
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {

        },
    });

    const { getFieldProps } = formik;

    return (
        <React.Fragment>
            <AvForm className="needs-validation" onValidSubmit={formik.handleSubmit}>
                <Card>
                    <CardBody>
                        <Row>
                            <Col md="12">
                                <Label className="form-check-label">{t('vvinale.courbeDepreciation')}</Label>
                                <AvField
                                    {...getFieldProps('courbeDepreciation')}
                                    type="text"
                                    placeholder={t('vvinale.courbeDepreciation')}
                                    errorMessage={t('message.required')}
                                    className="form-control"
                                    id="courbeDepreciation"
                                    disabled
                                />
                            </Col>
                            <Col md="12">
                                <Label className="form-check-label">{t('vvinale.VVADEsansCorrectif')}</Label>
                                {/* <AvField
                                    {...getFieldProps('vvadEsansCorrectif')}
                                    type="text"
                                    placeholder={t('vvinale.VVADEsansCorrectif')}
                                    errorMessage={t('message.required')}
                                    className="form-control"
                                    id="VVADEsansCorrectif"
                                /> */}
                                <CurrencyInput
                                    className="form-control"
                                    id="VVADEsansCorrectif"
                                    {...getFieldProps('vvadEsansCorrectif')}
                                    placeholder={t('vvinale.VVADEsansCorrectif')}
                                    groupSeparator=","
                                    decimalSeparator="."
                                    decimalsLimit={2}
                                    disabled
                                />
                            </Col>
                            <Col md="12">
                                <Label className="form-check-label">{t('vvinale.correctifEtatVehicule')}</Label>
                                <AvField
                                    {...getFieldProps('correctifEV')}
                                    type="text"
                                    placeholder={t('vvinale.correctifEtatVehicule')}
                                    errorMessage={t('message.required')}
                                    className="form-control"
                                    id="correctifEtatVehicule"
                                    disabled
                                />
                                
                                 <CurrencyInput
                                    className="form-control"
                                    id="correctifEtatVehicule"
                                    {...getFieldProps('correctifEtatVehicule')}
                                    placeholder={t('vvinale.correctifEtatVehicule')}
                                    groupSeparator=","
                                    decimalSeparator="."
                                    decimalsLimit={2}
                                    disabled
                                />
                            </Col>
                            <Col md="12">
                                <Label className="form-check-label">{t('vvinale.vvadEavecCorrectif1')}</Label>
                                 <CurrencyInput
                                    {...getFieldProps('vvadEavecCorrectif1')}
                                    placeholder={t('vvinale.vvadEavecCorrectif1')}
                                    className="form-control"
                                    id="vvadEavecCorrectif1"
                                    groupSeparator=","
                                    decimalSeparator="."
                                    decimalsLimit={2}
                                    disabled
                                />
                            </Col>
                            <Col md="12">
                                <Label className="form-check-label">{t('vvinale.correctifKilometrique')}</Label>
                                <AvField
                                    {...getFieldProps('correctifKilometrique')}
                                    type="text"
                                    placeholder={t('vvinale.correctifKilometrique')}
                                    errorMessage={t('message.required')}
                                    className="form-control"
                                    id="correctifKilometrique"
                                    disabled
                                />
                            </Col>
                            <Col md="12">
                                <Label className="form-check-label">{t('vvinale.vvadEavecCorrectif2')}</Label>
                                <AvField
                                    {...getFieldProps('vvadEavecCorrectif2')}
                                    type="text"
                                    placeholder={t('vvinale.vvadEavecCorrectif2')}
                                    errorMessage={t('message.required')}
                                    className="form-control"
                                    id="vvadEavecCorrectif2"
                                    disabled
                                />
                            </Col>
                            <Col md="12">
                                <Label className="form-check-label">{t('vvinale.correctifTotal')}</Label>
                                <AvField
                                    {...getFieldProps('correctifTotal')}
                                    type="text"
                                    placeholder={t('vvinale.correctifTotal')}
                                    errorMessage={t('message.required')}
                                    className="form-control"
                                    id="correctifTotal"
                                    disabled
                                />
                            </Col>
                            <Col md="12">
                                <Label className="form-check-label">{t('vvinale.VVADEavecCorrectifTotal')}</Label>
                                <AvField
                                    {...getFieldProps('vvadEavecCorrectifTotal')}
                                    type="text"
                                    placeholder={t('vvinale.VVADEavecCorrectifTotal')}
                                    errorMessage={t('message.required')}
                                    className="form-control"
                                    id="VVADEavecCorrectifTotal"
                                    disabled
                                />
                            </Col>
                            <Col md="12">
                                <Label className="form-check-label">{t('vvinale.epaveObtenueAssureur')}</Label>
                                <AvField
                                    {...getFieldProps('epaveObtenueAssureur')}
                                    type="text"
                                    placeholder={t('vvinale.epaveObtenueAssureur')}
                                    className="form-control"
                                    id="epaveObtenueAssureur"
                                    disabled
                                />
                            </Col>
                            <Col md="12">
                                <Label className="form-check-label">{t('vvinale.differenceValeurs')}</Label>
                                <AvField
                                    {...getFieldProps('differenceValeurs')}
                                    type="text"
                                    placeholder={t('vvinale.differenceValeurs')}
                                    errorMessage={t('message.required')}
                                    className="form-control"
                                    id="differenceValeurs"
                                    disabled
                                />
                            </Col>
                            <Col md="12">
                                <Label className="form-check-label">{t('vehiculef.coefCommercial')}</Label>
                                <AvField
                                    {...getFieldProps('montantCommercial')}
                                    type="text"
                                    placeholder={t('vehiculef.coefCommercial')}
                                    errorMessage={t('message.required')}
                                    className="form-control"
                                    id="montantCommercial"
                                    disabled
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </AvForm>
        </React.Fragment>
    );
};

export default ResultatForm;
